<ul class="tabs breadcrumb">
  @for (breadcrumb of breadcrumbList; track breadcrumb) {
    <li class="tabs-title"><a [ngClass]="{'is-active': curTab == breadcrumb.name}" routerLink="{{breadcrumb.link}}">{{breadcrumb.name}}</a></li>
  }
</ul>
